import Vue from 'vue';
import Router from 'vue-router';
// Containers

import DefaultContainer from '@/containers/DefaultContainer';
import PopupContainer from '@/containers/PopupContainer';

import Intro from '@/components/templates/Intro';
import PointHistory from '@/components/templates/PointHistory';
import ExchangeHistory from '@/components/templates/ExchangeHistory';
import UserInfo from '@/components/templates/userInfo/UserInfo';
import UserInfoView from '@/components/templates/userInfo/view/View';
import UserInfoRegister from '@/components/templates/userInfo/register/Register';
import UserInfoModify from '@/components/templates/userInfo/Modify';
import UserInfoHistory from '@/components/templates/userInfo/History';
import Auth from '@/components/templates/auth';
import AuthView from '@/components/templates/auth/view';
import AuthRegister from '@/components/templates/auth/register';
import Step1 from '@/components/templates/exchange/Step1';
import Step2 from '@/components/templates/exchange/Step2';
import Step3 from '@/components/templates/exchange/Step3';
import Step4 from '@/components/templates/exchange/Step4';
import ErrorPage from '@/components/templates/exchange/ErrorPage';
import GlobalWithdraw from '@/components/templates/GlobalWithdraw';

import { setServiceInfo, setServiceUrl, goToLoginPage } from '@/utils';
import sendLog from '@/utils/analistic';
import { getNeededLanguage } from '@/utils/lang';
import { exchangeApi } from '@/api';

Vue.use(Router);

const router = new Router({
  mode: 'history',
  linkActiveClass: 'open active',
  routes: [
    {
      path: '/',
      redirect: getNeededLanguage(),
    },
    {
      path: '/withdrawComplete',
      name: 'WithdrawComplete',
      component: DefaultContainer,
    },
    {
      path: '/:locale',
      component: DefaultContainer,
      children: [
        {
          path: '/',
          name: 'intro',
          component: Intro,
        },
        {
          name: 'UserInfo',
          path: 'userInfo',
          component: UserInfo,
          children: [
            {
              name: 'UserInfoView',
              path: 'view',
              component: UserInfoView,
            },
            {
              name: 'UserInfoRegister',
              path: 'register',
              component: UserInfoRegister,
            },
            {
              name: 'UserInfoModify',
              path: 'modify',
              component: UserInfoModify,
            },
            {
              name: 'UserInfoChange',
              path: 'change',
              component: UserInfoRegister,
            },
            {
              name: 'UserInfoHistory',
              path: 'history',
              component: UserInfoHistory,
            },
          ],
        },
        {
          name: 'Auth',
          path: '/:locale/auth',
          component: Auth,
          children: [
            {
              name: 'AuthView',
              path: '/',
              component: AuthView,
            },
            {
              name: 'AuthRegister',
              path: 'register',
              component: AuthRegister,
            },
          ],
        },
      ],
    },
    {
      path: '/:locale/intro.html',
      redirect: '/:locale',
    },
    {
      path: '/:locale/:serviceUrl/:children/intro.html',
      redirect: '/:locale/:serviceUrl/:children',
    },
    {
      path: '/:locale/:serviceUrl',
      component: DefaultContainer,
      redirect: '/:locale/:serviceUrl/pointHistory',
      children: [
        {
          name: 'PointHistory',
          path: 'pointHistory',
          component: PointHistory,
        },
        {
          name: 'ExchangeHistory',
          path: 'exchangeHistory',
          component: ExchangeHistory,
        },
      ],
    },
    {
      path: '/:locale/:serviceUrl',
      component: DefaultContainer,
      redirect: '/:locale/:serviceUrl/globalWithdraw',
      children: [
        {
          name: 'GlobalWithdrawInfo',
          path: 'globalWithdraw',
          component: GlobalWithdraw,
        },
        {
          name: 'GlobalWithdrawForm',
          path: 'globalWithdrawForm',
          component: GlobalWithdraw,
        },
        {
          name: 'GlobalWithdrawResult',
          path: 'globalWithdrawResult',
          component: GlobalWithdraw,
        },
      ],
    },
    {
      path: '/:locale/:serviceUrl/exchange',
      component: PopupContainer,
      redirect: '/:locale/:serviceUrl/exchange/step1',
      children: [
        {
          name: 'Step1',
          path: 'step1',
          component: Step1,
        },
        {
          name: 'Step2',
          path: 'step2',
          component: Step2,
        },
        {
          name: 'Step3',
          path: 'step3',
          component: Step3,
        },
        {
          name: 'Step4',
          path: 'step4',
          component: Step4,
        },
        {
          name: 'ErrorPage',
          path: 'errorPage',
          component: ErrorPage,
          props: true,
        },
      ],
    },
  ],
});

router.beforeEach(async (to, from, next) => {
  if (to.path.endsWith('/intro.html')) {
    next('/');
  }

  if (to.params?.serviceUrl) {
    setServiceUrl(to.params.serviceUrl);
    setServiceInfo(to.params);
  }

  // 뒤로 갈 때  path를 보고 i18n locale 재 설정. (MSW와 같은 방식)
  if (router.app.$i18n) {
    if (to.params.locale) {
      router.app.$i18n.locale = to.params.locale;
    }
  }

  if (to.params.locale === 'kr') {
    next(to.fullPath.replace('/kr', '/ko'));
  }

  // 포인트 전환 신청 페이지 접근 제한
  let stateLog = true;
  if (to.path.split('/')[2] == 'exchange') {
    if (to.name !== 'Step1' && from.name === null && to.params?.serviceUrl) {
      next(`/${to.params?.serviceUrl}/exchange/step1`);
      stateLog = false;
    }
  }

  // A2S
  let viewId = '';
  switch (to.name) {
    case 'PointHistory':
      viewId = 'pointHistory';
      break;
    case 'ExchangeHistory':
      viewId = 'exchangeHistory';
      break;
    case 'Step1':
      viewId = 'exchange_step1';
      break;
    case 'Step2':
      viewId = 'exchange_step2';
      break;
    case 'Step3':
      viewId = 'exchange_step3';
      break;
    case 'Step4':
      viewId = 'exchange_step4';
      break;
    default:
      break;
  }
  if (stateLog === true) {
    sendLog(viewId, { servicename: to.params?.serviceUrl }, 'contents');
  }

  // tipalti
  if (to.path.split('/')[1] == 'withdrawComplete') {
    if (to.query.orderId) {
      const tipalti = localStorage.getItem('tipalti');
      if (!tipalti) {
        next('/');
      }
      const { serviceUrl, cashAmount, currencyCode, payAmount, uiCulture, redirectURL, lang } = JSON.parse(tipalti);
      setServiceUrl(serviceUrl); // api base를 꼭 거쳐야하는 구조여서 추가함... ㅋ
      const response = await exchangeApi.excutionWithdraw({
        orderID: to.query.orderId,
        cashAmount,
        currencyCode,
        payAmount,
        uiCulture,
        redirectURL,
      });
      const { code } = response.data;
      let statusQueryParam = 'fail';
      if (code === 0) {
        statusQueryParam = 'success';
      } else if (code === 2) {
        goToLoginPage();
      } else {
        statusQueryParam = 'fail';
      }
      next({
        path: `/${lang}/${serviceUrl}/globalWithdrawResult`,
        query: {
          ...to.query,
          status: statusQueryParam,
        },
      });
    }
  }

  next();
});

export default router;
